import { connect } from "react-redux";
import { useState } from "react";
import { get_credit_history_for_account } from "./actions";

const mapStateToProps = (state) => {
  return {
    userApplications: state.userCreditHistory.applications.data,
    userCreditApplications: state.userCreditHistory.creditApplications.data,
    userLoans: state.userCreditHistory.loans.data,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchCreditHistory: (accountId) => {
      dispatch(get_credit_history_for_account(accountId));
    },
  };
};

export const withUserCreditHistory = (Cmp) => (props) => {
  const [fetching, setFetching] = useState(false);
  const dataAlreadyFetched =
    props.userLoans[props.accountId] &&
    props.userApplications[props.accountId] &&
    props.userCreditApplications[props.accountId];

  if (!dataAlreadyFetched) {
    if (!fetching) {
      setFetching(true);
      props.fetchCreditHistory(props.accountId);
    }

    return <div>Loading...</div>;
  }

  return (
    <Cmp
      {...props}
      userLoans={props.userLoans[props.accountId]}
      userApplications={props.userApplications[props.accountId]}
      userCreditApplications={props.userCreditApplications[props.accountId]}
    />
  );
};

export const creditHistoryConnector = connect(
  mapStateToProps,
  mapDispatchToProps,
);
